export const routeFactory = {
  home: {
    root: () => '/',
  },
  contact: () => '/kontakta-oss',
  advertiseAtTv4: {
    root: () => '/annonsera-hos-tv4',
  },
  current: {
    root: () => '/aktuellt',
    news: () => '/aktuellt/?category=nyheter',
    insights: () => 'aktuellt/?category=insikter',
    case: () => '/aktuellt/?category=case',
    event: () => '/aktuellt/?category=event'
  },
  educationAndEvents: {
    root: '/utbildning-event',
    education: () => '/utbildning-event/event/',
  },
  sport: () => '/sport',
  cookies: () => '/cookiepolicy/',
  integrity: () => '/integritetspolicy/',
  digital: {
    root: () => '/digital',
  }
};